
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shortName]/lock-met/positions",
      function () {
        return require("private-next-pages/[shortName]/lock-met/positions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shortName]/lock-met/positions"])
      });
    }
  